import React, { useState,useEffect } from "react";
import Logo from "../../Assests/Images/tfs_logo.png";
import styles from "./CreateAccount.module.scss";
import Card from "../../Components/Atoms/Card/Card";
import ErrorLabel from "../../Components/Atoms/ErrorLabel/ErrorLabel";
import {
  FormDropdown,
  FormField,
  FormTextArea,
  FormFieldMail,
} from "../../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PrimaryButton } from "../../Components/Atoms/Button/Button";
import { useNavigate } from "react-router-dom";
import OtpInput from "../../Components/Atoms/OtpInput/OtpInput";
import { FaTemperatureHigh } from "react-icons/fa";

import {get_master_data,enquiry,enquiry_otp} from "../../Enums/api_constunts"
import _ from "lodash"
import {postMethod} from "../../Helpers/services"
import { showToast } from "../../Components/Atoms/ToastNotifier/ToastNotifier";
import { useParams,useLocation } from 'react-router-dom';

export default function CreateAccount() {
  const navigateTo = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tenant_id = searchParams.get('tenant_id');
  const [isSpinner, setIsSpinner] = useState(false);
  const [isOtpField, setOtpField] = useState(false);
  const [isServiceEnable, setIsServiceEnable] = useState(false);
  const [serviceTypes,setServiceTypes] = useState([])
  const [selectedServiceType, setSelectedServiceType] = useState(null)
  const [newUser, setNewUser] = useState(null)
  const getMasterData = ()=>{
    let postData = {"categories":["md_service_types"]};
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
      

     let md_service_types =   _.get(res,"result.md_service_types",[]).map((item)=>{
        item["label"] =  item["name"]
        
        return item
      });
      setServiceTypes(md_service_types)
      
    })
  }

  useEffect(()=>{
    getMasterData()
  },[]);

 const [formData,setFormData] = useState(null)
  const handleSubmit = (data) => {
    let postData = {...data};
    
    if(_.has(postData,"mobile_no")){
      let mobile_no  = postData["mobile_no"].trim()
      if (mobile_no.startsWith("+91-")) {
        
      } else {
        mobile_no = `+91-${mobile_no}`;
      }
      postData["mobile_no"] =  mobile_no;

    }
    setIsSpinner(true);
    
    if(_.get(selectedServiceType,"id",false)){
      postData["service_type_id"] = selectedServiceType["id"]
    }
    if(tenant_id && tenant_id>0){
      postData["tenant_id"] = tenant_id
    }
    
    
    postMethod(enquiry_otp,postData).then((res)=>{
      setOtpField(true);
      setFormData(postData);
    }).catch((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);
      setOtpField(false);

    });
  };
  const submitAction = (data) => {
    console.log(JSON.stringify(data))
    setIsSpinner(true);
    let postData = {...data};
    if(_.get(selectedServiceType,"id",false)){
      postData["service_type_id"] = selectedServiceType["id"]
    }
    if(tenant_id && tenant_id>0){
      postData["tenant_id"] = tenant_id
    }
    postMethod(enquiry,postData).then((res)=>{
      setNewUser(res.result)
      setIsSpinner(false);
      setOtpField(true);
      showToast("success",_.get(res, "message","Success"))
      formik.setFieldValue("name", "");
      formik.setFieldValue("email", "");
      formik.setFieldValue("service", "");
      formik.setFieldValue("description", "");
      formik.setFieldValue("mobile_no", "");
      setOtpField(false);
     }).
     catch((error)=>{
      setOtpField(false);
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

     })
  };
  
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      service: "",
      description: "",
      mobile_no: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required").min(2, "Must be at least 2 characters").max(50, "Must be 50 characters or less"),
      email: Yup.string().email("Invalid email address").required("Email is required") .min(2, "Must be at least 2 characters").max(50, "Must be 50 characters or less"),
      mobile_no: Yup.string().required("Please enter your mobile number"),
      //service: Yup.string().required("Please select service"),
    }),
    onSubmit: handleSubmit,
    
  });

  const handleCloseModal =()=>{
    setIsSpinner(false);
    setOtpField(false);
  } 
  const handleOTPComplete =(value)=>{
    
    setFormData({...formData,"otp":value})
    submitAction({...formData,"otp":value});

  }

  const handleKeyDown = (event) => {
  
    
    if (event.key === 'Enter') {
      
      formik.handleSubmit()
      
    }
  };
  

  return (
    <div className={styles.outer_container}>
      <div>
        {/* <div className="d-flex justify-content-between align-items-center bg-light position-absolute">
          <img src={Logo} alt="logo" height="70px" />
        </div> */}
       
        <div className={styles.create_account}>
          <div className={styles.create_account_container}>
            <Card className={styles.cardDetails}>
              <div className="text-center">
                <img src={Logo} alt="logo" height="70px" />
                <p className="d-flex flex-column mt-1">
                  <span className={`fs-2 lh-1 fw-bold ${styles.loginTitle}`}>
                  Enquiry
                  </span>
                  {/* <span className="fs-6 lh-1 mt-3">Welcome back!</span> */}
                </p>
              </div>
              
              <div className="d-flex flex-column justify-content-center align-items-center mt-3">
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Name"
                    id="name"
                    name="name"
                    type="text"
                    value={formik.values.name}
                    onChange={(e) =>
                      formik.setFieldValue("name", e.target.value)
                    }
                    error={formik.touched.name && formik.errors.name}
                    disableNumbers={true}
                    disableSymbols={true}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.name && (
                    <ErrorLabel
                      name="name"
                      formik={formik}
                      message={formik.errors.name}
                    />
                  )}
                </div>
               
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Email Address"
                    id="email"
                    name="email"
                    type="email"
                    value={formik.values.email}
                    onChange={(e) =>
                      formik.setFieldValue("email", e.target.value)
                    }
                    error={formik?.touched.email && formik.errors.email}
                    disableNumbers={false}
                    disableSymbols={false}
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.email && (
                    <ErrorLabel
                      name="email"
                      formik={formik}
                      message={formik.errors.email}
                    />
                  )}
                </div>
                <div className="mb-2" onKeyDown={handleKeyDown}>
                  <FormField
                    label="Mobile Number"
                    id="mobile_no"
                    name="mobile_no"
                    type="text"
                    value={formik.values.mobile_no}
                    onChange={(e) =>
                      formik.setFieldValue("mobile_no", e.target.value)
                    }
                    error={formik.touched.mobile_no && formik.errors.mobile_no}
                    disableNumbers={false}
                    disableAlphebets={true}
                    disableSymbols={false}
                    isImportant={false}
                    onBlur={formik.handleBlur}
                    className={styles.formField}
                  />
                  {formik.touched.mobile_no && (
                    <ErrorLabel
                      name="mobile_no"
                      formik={formik}
                      message={formik.errors.mobile_no}
                    />
                  )}
                </div>
                
                {isOtpField && (
                  <OtpInput
                    isModalOpen={true}
                    handleClose={handleCloseModal}
                    numInputs={6}
                    onComplete={handleOTPComplete}
                    separator=" "
                    isNumeric={true}
                    otpStatus={"error"}
                    spinner={false}
                   // handleResendOtp={handleOTPComplete}
                  />
                )}
                
                 {false&& <div className="mb-2">
                    <FormDropdown
                      id="service"
                      name="service"
                      label="Services"
                      options={serviceTypes}
                      onChange={(selected) => {
                        setSelectedServiceType(selected)
                        formik.setFieldValue("service", selected?.id);
                      }}
                      isImportant={false}
                      value={formik.values.service}
                      error={formik.touched.service && formik.errors.service}
                      onBlur={formik.handleBlur}
                      className={styles.formField}
                    />
                    <ErrorLabel
                      name="service"
                      formik={formik}
                      message={formik.errors.service}
                    />
                  </div>
                  }
                
                
              </div>
              <div className="text-center">
                
                  <PrimaryButton
                    label="Submit"
                    className={styles.otpButton}
                    onClick={formik.handleSubmit}
                    disabled={!(formik.dirty && formik.isValid)}
                    spinner={isSpinner}
                  />
                
              </div>
              <p
                className={`fs-3 lh-1 fw-bold text-center ${styles.logintext}`}
                onClick={() => navigateTo("/customer-login")}
              >
                Back to Login
              </p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
